// export const SITE_URL = "https://test.tutorshell.com"; // change branch to master when need to build this app for beta
export const SITE_URL = "https://app.tutorshell.com"; // change branch to master when need to build this app for live
// export const SITE_URL = "http://tutorapi.test";
export const BASE_URL = `${SITE_URL}/api`;
export default SITE_URL;
